var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('wx-work-list-panel',{attrs:{"work-list":_vm.workList,"history":true,"technician-id-map":_vm.technicianIdMap,"team-id-map":_vm.teamIdMap}})}
var staticRenderFns = []

export { render, staticRenderFns }